<div class="row">
    <div class="col-6">
        <h1>Compañias</h1>
    </div>
    <div class="col-6 ">
            <app-add-company></app-add-company>
    </div>
</div>


<!--app-add-company-->
<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Compañia</th>
                        <th scope="col">Dirección</th>
                        <th scope="col">Teléfono</th>
                        <th scope="col">Email</th>
                        <th scope="col">Contacto</th>
                        <th scope="col">Estatus</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let company of companies">
                        <td>{{ company.name }}</td>
                        
                        <td>{{ company.address1 }}, {{ company.address2 }}<br/>{{ company.city }} {{ company.state }} {{ company.zip }}</td>
                        <td>{{ company.phone}}</td>
                        <td>{{ company.email }}</td>
                        <td><b>{{ company.contact }}</b><br/>{{ company.contactPhone }}<br/>{{ company.contactEmail }}</td>
                        <td *ngIf="company.active">Active</td>
                        <td *ngIf="!company.active">Inactive</td>
                        <td><button type="button" (click)="companyDetails(company.id)" class="btn btn-secondary">Detalles</button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>